import React from "react";
import PropTypes from "prop-types";
import Link from "../Link";
import List from "../List";
import BreadcrumbStyle, { CrumbItem } from "./Breadcrumb.Style";

const Breadcrumb = (props) => {
  const { crumbs } = props;

  const renderItem = ({ label, href }) => (
    <CrumbItem as={Link} textSize="sm" href={href || null} disabled={!href}>
      {label}
    </CrumbItem>
  );
  return (
    <BreadcrumbStyle
      {...props}
      as={List}
      listItems={crumbs}
      forEach={renderItem}
    />
  );
};

Breadcrumb.defaultProps = {
  crumbs: [],
};

Breadcrumb.propTypes = {
  crumbs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string,
    })
  ),
};

export default Breadcrumb;
